// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import MetaInfo from 'vue-meta-info'
import store from './store'
import { Loading,Table, TableColumn,Dialog,Button ,Pagination,Message,Image } from 'element-ui'
import 'babel-polyfill'
import './assets/css/reset.css'
import './assets/css/common.css'
Vue.use(Loading.directive)
Vue.config.productionTip = false
Vue.use(MetaInfo)
Vue.use(Dialog);
Vue.use(Table);
Vue.use(Button);
Vue.use(TableColumn);
Vue.use(Pagination);
Vue.use(Image);
Vue.prototype.$message = Message

/* eslint-disable no-new */
router.beforeEach((from, to, next) => {
	const namesList = ['ProRecordCer','ProTraceabilityCer']
	let nameval = to.name
	// 判断哪些页面不需要加公用的头部尾部
	if (namesList.indexOf(nameval) > -1) {
	    store.commit('setIncludeShow', false)
	} else {
	    store.commit('setIncludeShow', true)
	}
    document.body.scrollTop = 0
    document.documentElement.scrollTop = 0
    next()

})



new Vue({
    el: '#app',
    router,
    store,
    render: h => h(App),

    /* 这句非常重要，否则预渲染将不会启动 */
    mounted () {
        document.dispatchEvent(new Event('render-event'))
    }
})



// WEBPACK FOOTER //
// ./src/main.js